import axios from 'axios';
import {
  GET_PAYMENT_REQUEST_TRANSACTIONS_REQUEST,
  GET_PAYMENT_REQUEST_TRANSACTIONS_SUCCESS,
  GET_PAYMENT_REQUEST_TRANSACTIONS_FAILURE,
  RESET_PAYMENT_REQUEST_PAGINATION,
  CREATE_PAYMENT_REQUEST_REQUEST,
  CREATE_PAYMENT_REQUEST_SUCCESS,
  CREATE_PAYMENT_REQUEST_FAILURE,
  CREATE_DIRECT_PAYMENT_REQUEST_REQUEST,
  CREATE_DIRECT_PAYMENT_REQUEST_SUCCESS,
  CREATE_DIRECT_PAYMENT_REQUEST_FAILURE,
  MARK_PAYMENT_REQUEST_TRANSACTION_COMPLETED,
  FAST_DEPOSIT_VIEW_PAGE,
  FAST_DEPOSIT_CLICK_SEND_REQUEST,
  FAST_DEPOSIT_CLICK_CANCEL_BUTTON,
  FAST_DEPOSIT_CLICK_CONFIRM_BUTTON,
  FAST_DEPOSIT_CLICK_HOW_TO_BUTTON,
  FAST_DEPOSIT_CLICK_HELP_BUTTON,
  FAST_DEPOSIT_CLICK_CANCEL_INFO,
  FAST_DEPOSIT_VIEW_CANCEL_REASON,
  FAST_DEPOSIT_CLICK_RETRY_BUTTON
} from 'Store/constants';
import ProjectConfig from 'ProjectConfig';

const API_GATEWAY = ProjectConfig.API_GATEWAY;

export const getPaymentRequestTransactions = (params = {}) => async dispatch => {
  const defaultParams = {
    dateFilter: 'ALL',
    statusFilter: 'ALL',
    page: 0,
    size: 3
  };

  const requestParams = { ...defaultParams, ...params };

  try {
    dispatch({
      type: GET_PAYMENT_REQUEST_TRANSACTIONS_REQUEST
    });

    const res = await axios.get(`${API_GATEWAY}/payment-request/transactions`, {
      params: requestParams
    });

    dispatch({
      type: GET_PAYMENT_REQUEST_TRANSACTIONS_SUCCESS,
      payload: res.data
    });

    return res.data;
  } catch (e) {
    dispatch({
      type: GET_PAYMENT_REQUEST_TRANSACTIONS_FAILURE,
      payload: e.response?.data?.message || 'İşlemler yüklenemedi'
    });

    throw e;
  }
};

export const resetPaymentRequestPagination = () => ({
  type: RESET_PAYMENT_REQUEST_PAGINATION
});

export const createPaymentRequest = ({ iban, paymentAmount }) => async dispatch => {
  try {
    dispatch({
      type: CREATE_PAYMENT_REQUEST_REQUEST
    });

    await axios.post(`${API_GATEWAY}/payment-request`, {
      iban,
      paymentAmount: Number(paymentAmount)
    });

    dispatch({
      type: CREATE_PAYMENT_REQUEST_SUCCESS
    });

    return { success: true };
  } catch (e) {
    const errorData = e.response?.data || { message: 'İşlem başarısız oldu' };

    dispatch({
      type: CREATE_PAYMENT_REQUEST_FAILURE,
      payload: errorData
    });

    return { success: false, error: errorData };
  }
};

export const createDirectPaymentRequest = ({ iban, paymentAmount, userId }) => async dispatch => {
  try {
    dispatch({
      type: CREATE_DIRECT_PAYMENT_REQUEST_REQUEST
    });

    await axios.post(`${API_GATEWAY}/payment-request/direct`, {
      iban,
      paymentAmount: Number(paymentAmount),
      userId
    });

    dispatch({
      type: CREATE_DIRECT_PAYMENT_REQUEST_SUCCESS
    });

    return { success: true };
  } catch (e) {
    const errorData = e.response?.data || { message: 'İşlem başarısız oldu' };

    dispatch({
      type: CREATE_DIRECT_PAYMENT_REQUEST_FAILURE,
      payload: errorData
    });

    return { success: false, error: errorData };
  }
};

export const markPaymentRequestTransactionCompleted = lastTransactionId => ({
  type: MARK_PAYMENT_REQUEST_TRANSACTION_COMPLETED,
  payload: lastTransactionId
});

// Fast Deposit Analytics Actions
export const trackFastDepositViewPage = ({ ibanCount, bankNames }) => ({
  type: FAST_DEPOSIT_VIEW_PAGE,
  payload: { ibanCount, bankNames }
});

export const trackFastDepositClickSendRequest = ({ paymentRequestPoint }) => ({
  type: FAST_DEPOSIT_CLICK_SEND_REQUEST,
  payload: { paymentRequestPoint }
});

export const trackFastDepositClickCancelButton = () => ({
  type: FAST_DEPOSIT_CLICK_CANCEL_BUTTON
});

export const trackFastDepositClickConfirmButton = ({ amount }) => ({
  type: FAST_DEPOSIT_CLICK_CONFIRM_BUTTON,
  payload: { amount }
});

export const trackFastDepositClickHowToButton = () => ({
  type: FAST_DEPOSIT_CLICK_HOW_TO_BUTTON
});

export const trackFastDepositClickHelpButton = ({ amount, bankName }) => ({
  type: FAST_DEPOSIT_CLICK_HELP_BUTTON,
  payload: { amount, bankName }
});

export const trackFastDepositClickCancelInfo = ({ amount, bankName }) => ({
  type: FAST_DEPOSIT_CLICK_CANCEL_INFO,
  payload: { amount, bankName }
});

export const trackFastDepositViewCancelReason = ({ cancelReason }) => ({
  type: FAST_DEPOSIT_VIEW_CANCEL_REASON,
  payload: { cancelReason }
});

export const trackFastDepositClickRetryButton = () => ({
  type: FAST_DEPOSIT_CLICK_RETRY_BUTTON
});

